export function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
export function getAbbreviation() {
    let text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '', limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var _text_match;
    const textArray = (_text_match = text.match(/\b([A-Za-z0-9])/g)) !== null && _text_match !== void 0 ? _text_match : [];
    if (textArray.length >= limit) {
        return textArray.slice(0, limit).join('').toUpperCase();
    }
    return text.slice(0, 2).toUpperCase();
}
/**
 * Set copyString to the clipboard.
 *
 * @param copyString String to copy.
 * @param onSuccess On success copy action.
 * @param onError On failed copy action.
 */ export const copyToClipboard = async (copyString, onSuccess, onError)=>{
    try {
        await navigator.clipboard.writeText(copyString);
        if (onSuccess) {
            onSuccess();
        }
    } catch (err) {
        if (onError && err instanceof Error) {
            onError(err);
        }
    }
};
export const cutString = (length, str)=>{
    if (!str) {
        return undefined;
    }
    return str.length > length ? "".concat(str.slice(0, length), "...") : str;
};
